import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HwLogDto } from '@app/dto/HwLogDto';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })

export class LogService {
 
  constructor(
    private http: HttpClient
  ) { }

  WriteLogItem(data: HwLogDto) {
    const headers = new HttpHeaders().set("Content-Type","application/json");
    return (this.http.post(environment.exiBackendUrl+ "/api/exi/photo/PostLog",data,{headers}))
  }
}